import React from 'react';

//==================Externals==================//
import classNames from 'classnames';
import PropTypes from 'prop-types';

//==================Styles==================//
import styles from './styles';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles(styles);

const Status = (props) => {
  //==================Variables==================//
  const { className, size, color, ...rest } = props;
  const classes = useStyles();
  const rootClassName = classNames(
    {
      [classes.root]: true,
      [classes[size]]: size,
      [classes[color]]: color,
    },
    className
  );

  return <span {...rest} className={rootClassName} />;
};

//==================PropTypes==================//
Status.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf([
    'neutral',
    'primary',
    'info',
    'success',
    'warning',
    'danger',
  ]),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
};

Status.defaultProps = {
  size: 'md',
  color: 'default',
};

export default Status;
